import {
  createContext,
  useContext,
  ReactNode,
  FunctionComponent,
  useMemo,
} from 'react'
import { SearchForCollectionProperties } from '@/utils/ampli'

interface CollectionSearchEventAtContextType {
  at?: SearchForCollectionProperties['at']
  children?: ReactNode
}

const CollectionSearchEventAtContext =
  createContext<CollectionSearchEventAtContextType>({})

export const CollectionSearchEventAtProvider: FunctionComponent<
  CollectionSearchEventAtContextType
> = ({ children, at }) => {
  const value = useMemo(() => {
    return { at }
  }, [at])

  return (
    <CollectionSearchEventAtContext.Provider value={value}>
      {children}
    </CollectionSearchEventAtContext.Provider>
  )
}

export const useCollectionSearchEventAt =
  (): CollectionSearchEventAtContextType =>
    useContext(CollectionSearchEventAtContext)
